package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.ui.theme.PaletteId
import er.prateek.crossly.ui.theme.ThemeMode

private const val KEY_THEME_MODE = "theme_mode"
private const val KEY_THEME_PALETTE = "theme_palette"

class SettingsThemeStore(
    private val settings: Settings,
) : ThemeStore {
    override fun load(): ThemePreferences {
        val mode = settings.getStringOrNull(KEY_THEME_MODE)
            ?.let { runCatching { ThemeMode.valueOf(it) }.getOrNull() }
            ?: ThemeMode.SYSTEM
        val paletteId = settings.getStringOrNull(KEY_THEME_PALETTE)
            ?.let { runCatching { PaletteId.valueOf(it) }.getOrNull() }
            ?: PaletteId.CLASSIC
        return ThemePreferences(mode, paletteId)
    }

    override fun save(preferences: ThemePreferences) {
        settings.putString(KEY_THEME_MODE, preferences.mode.name)
        settings.putString(KEY_THEME_PALETTE, preferences.paletteId.name)
    }
}
